/*
 * Exkluzivní accordion pro stránku Nezávislé testování.
 *
 * Nativní <details> umí otevřít všechny položky najednou a obsah skáče.
 * Tady otevření jedné položky zavře ostatní a výška se animuje. Bez JS
 * zůstává nativní chování s první položkou otevřenou.
 */
(function () {
  var items = document.querySelectorAll('details.lab-cert-page__item');
  if (!items.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bodyOf(details) {
    return details.querySelector('.lab-cert-page__body');
  }

  function clear(body, details) {
    body.style.cssText = '';
    delete details.dataset.animating;
  }

  function open(details) {
    if (details.dataset.animating) return;
    var body = bodyOf(details);
    details.open = true;
    if (reduceMotion) return;

    details.dataset.animating = '';
    var target = body.offsetHeight;
    body.style.boxSizing = 'border-box';
    body.style.height = '0px';
    requestAnimationFrame(function () {
      body.style.transition = 'height 0.25s ease';
      body.style.height = target + 'px';
    });
    body.addEventListener('transitionend', function () {
      clear(body, details);
    }, { once: true });
  }

  function close(details) {
    var body = bodyOf(details);
    if (details.dataset.animating) {
      // Rychlé přepnutí na jinou položku: probíhající animaci dokončíme
      // okamžitě, jinak by položka zůstala otevřená a accordion by měl
      // otevřené dvě.
      details.open = false;
      clear(body, details);
      return;
    }
    if (reduceMotion) {
      details.open = false;
      return;
    }
    details.dataset.animating = '';
    body.style.boxSizing = 'border-box';
    body.style.height = body.offsetHeight + 'px';
    requestAnimationFrame(function () {
      body.style.transition = 'height 0.25s ease';
      body.style.height = '0px';
    });
    body.addEventListener('transitionend', function () {
      details.open = false;
      clear(body, details);
    }, { once: true });
  }

  items.forEach(function (details) {
    var summary = details.querySelector('.lab-cert-page__summary');
    if (!summary) return;

    summary.addEventListener('click', function (event) {
      event.preventDefault();
      if (details.dataset.animating) return;
      if (details.open) {
        close(details);
      } else {
        items.forEach(function (other) {
          if (other !== details && other.open) close(other);
        });
        open(details);
      }
    });
  });
})();
